import { render, staticRenderFns } from "./popup.vue?vue&type=template&id=dac0c5e0&scoped=true"
import script from "./popup.vue?vue&type=script&lang=js"
export * from "./popup.vue?vue&type=script&lang=js"
import style0 from "./popup.vue?vue&type=style&index=0&id=dac0c5e0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dac0c5e0",
  null
  
)

export default component.exports